import { App, Button } from 'antd'
import { CheckCircle2, Code2, Copy, Info } from 'lucide-react'
import { cn } from '@/utils/index.ts'
import { createMcpConfig } from './utils/mcp-config.ts'

export function McpClientConfig({
  endpoint,
  secret: key,
  disabled
}: {
  endpoint: string
  secret?: string
  disabled: boolean
}) {
  const { message } = App.useApp()
  const config = createMcpConfig(endpoint, key)
  const copyConfig = async () => {
    try {
      await navigator.clipboard.writeText(config)
      void message.success(key ? 'MCP 配置已复制' : '配置模板已复制，请填入已保存的密钥')
    } catch {
      void message.error('无法访问剪贴板，请手动选中下方 JSON 复制')
    }
  }
  const StatusIcon = key ? CheckCircle2 : Info
  return (
    <section aria-label="AI 客户端配置" className="flex min-w-0 flex-col gap-2.5">
      <div className="flex items-center justify-between gap-2">
        <span className="text-content text-sm font-medium">客户端配置</span>
        <span className="text-content-soft text-xs">复制后粘贴至 AI 客户端的 MCP 设置</span>
      </div>
      <div className="border-border overflow-hidden rounded-lg border">
        <div className="border-border bg-surface-muted flex flex-wrap items-center justify-between gap-2 border-b px-4 py-2">
          <span className="text-content-muted flex items-center gap-2 font-mono text-xs">
            <Code2 aria-hidden className="size-4" />
            mcpServers.json
          </span>
          <Button
            size="small"
            type={key ? 'primary' : 'default'}
            icon={<Copy size={14} />}
            onClick={() => void copyConfig()}
            disabled={disabled}
          >
            {key ? '复制 JSON 配置' : '复制 JSON 模板'}
          </Button>
        </div>
        <pre
          className="text-content bg-surface m-0 max-h-56 overflow-auto p-4 font-mono text-xs leading-5"
          tabIndex={0}
          aria-label="MCP JSON 配置"
        >
          <code>{config}</code>
        </pre>
      </div>
      <p
        className={cn('m-0 flex items-start gap-2 text-xs leading-5', key ? 'text-accent' : 'text-content-muted')}
        role="status"
      >
        <StatusIcon aria-hidden className="mt-0.5 size-3.5 shrink-0" />
        <span>
          {key
            ? '配置已就绪，请在关闭前复制。完整密钥仅展示一次。'
            : '当前为配置模板。创建或重置密钥后，可复制完整配置。'}
        </span>
      </p>
    </section>
  )
}
